import { z } from 'zod';
import { DateOnlySchema, IdSchema, PageInfoSchema, TimestampSchema } from './common.js';
export const TaskStatusSchema = z.enum([
    'todo',
    'in_progress',
    'blocked',
    'completed',
    'cancelled',
]);
export const TaskPrioritySchema = z.enum(['low', 'normal', 'high', 'urgent']);
export const TaskSchema = z.strictObject({
    id: IdSchema,
    organizationId: IdSchema,
    projectId: IdSchema.nullable(),
    parentTaskId: IdSchema.nullable(),
    title: z.string(),
    description: z.string().nullable(),
    status: TaskStatusSchema,
    priority: TaskPrioritySchema,
    dueDate: DateOnlySchema.nullable(),
    assigneeMembershipId: IdSchema.nullable(),
    completedAt: TimestampSchema.nullable(),
    createdAt: TimestampSchema,
    updatedAt: TimestampSchema,
});
export const CreateTaskRequestSchema = z.strictObject({
    projectId: IdSchema.nullable().default(null),
    parentTaskId: IdSchema.nullable().default(null),
    title: z.string().trim().min(1).max(300),
    description: z.string().trim().max(10_000).nullable().default(null),
    status: TaskStatusSchema.default('todo'),
    priority: TaskPrioritySchema.default('normal'),
    dueDate: DateOnlySchema.nullable().default(null),
    assigneeMembershipId: IdSchema.nullable().default(null),
});
export const UpdateTaskRequestSchema = CreateTaskRequestSchema.partial();
export const TaskListSchema = z.strictObject({ items: z.array(TaskSchema), page: PageInfoSchema });
